import React, { useContext } from "react";

import "./About.css";
import { ThemeContext } from "../../contexts/ThemeContext";
import { aboutData } from "../../data/aboutData";

function About() {
  const { theme } = useContext(ThemeContext);
  return (
    <div
      className="about"
      id="about"
      style={{ backgroundColor: theme.secondary }}
    >
      <div className="line-styling">
        <div
          className="style-circle"
          style={{ backgroundColor: theme.primary }}
        ></div>
        <div
          className="style-circle"
          style={{ backgroundColor: theme.primary }}
        ></div>
        <div
          className="style-line"
          style={{ backgroundColor: theme.primary }}
        ></div>
      </div>
      <div className="about-body">
        <div className="about-description">
          <h2 style={{ color: theme.primary }}>WORK EXPERIENCE</h2>
          <h3 style={{ color: theme.primary400 }}>{aboutData[0].title}</h3>
          <h5 style={{ color: theme.primary }}>{aboutData[0].sub_title}</h5>
          <p style={{ color: theme.tertiary80, textAlign: "justify" }}>
            <br />
            <br />
            {aboutData[0].description1}
            <br />
            <br />
            {aboutData[0].description2}
            <br />
            <br />
            {aboutData[0].description3}
          </p>
        </div>
        <div className="about-img">
          <img
            src="https://i.ibb.co/G09H9yX/sodapdf-converted-g-Lca-ZHLGwj-transformed.png"
            alt=""
          />
          <img
            src="https://i.ibb.co/MhJxVkB/nvidia.png"
            // src="https://i.ibb.co/G09H9yX/sodapdf-converted-g-Lca-ZHLGwj-transformed.png"
            height="200px"
            alt=""
          />
        </div>
      </div>
      <div className="about-body">
        <div className="about-img">
          <img
            src="https://deltax.com/wp-content/uploads/2023/01/dx-logo-white-green-raw.png"
            alt=""
          />
        </div>
        <div className="about-description">
          <h3 style={{ color: theme.primary400 }}>{aboutData[1].title}</h3>
          <h5 style={{ color: theme.primary }}>{aboutData[1].sub_title}</h5>
          <p style={{ color: theme.tertiary80, textAlign: "justify" }}>
            <br />
            <br />
            {aboutData[1].description1}
            <br />
            <br />
            {aboutData[1].description2}
            <br />
            <br />
            {aboutData[1].description3}
            <br />
            <br />
            {aboutData[1].description4}
            <br />
            <br />
            {aboutData[1].description5}
            <br />
            <br />
            {aboutData[1].description6}
          </p>
        </div>
      </div>
      <div className="about-body">
        <div className="about-description">
          <h3 style={{ color: theme.primary400 }}>{aboutData[2].title}</h3>
          <h5 style={{ color: theme.primary }}>{aboutData[2].sub_title}</h5>
          <p style={{ color: theme.tertiary80, textAlign: "justify" }}>
            <br />
            <br />
            {aboutData[2].description1}
            <br />
            <br />
            {aboutData[2].description2}
            <br />
            <br />
            {aboutData[2].description3}
            <br />
            <br />
            {aboutData[2].description4}
            <br />
            <br />
            {aboutData[2].description5}
          </p>
        </div>
        <div className="about-img">
          <img
            src="https://i.ibb.co/MpSkwmX/agrogram-image-removebg-preview.png"
            alt=""
          />
        </div>
      </div>
    </div>
  );
}

export default About;
